/**
 * Register.tsx — redirects to Login.
 *
 * All registration is now handled inside Login.tsx via the magic-link
 * multi-step flow: email → (new user) → profile → magic link sent.
 *
 * This route is kept so that any old /register links still work.
 */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Register: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login", { replace: true });
  }, [navigate]);

  return null;
};

export default Register;
